import { StyleSheet, Dimensions } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    position: 'relative',
    backgroundColor: Colors.white,
  },
  headerBackground: (top = 0) => {
    return {
      width: width,
      height: 210 + top,
      backgroundColor: Colors.offWhite,
      paddingTop: top,
      position: 'relative',
    }
  },
  container: {
    flex: 1,
  },
  headerOfferTitle: {
    marginHorizontal: 16,
  },
  headerContentContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginVertical: 8,
  },
  fillRemainingSpace: {
    flexGrow: 1,
  },

  cover: {
    height: 210,
    flexDirection: 'row',
    position: 'relative',
  },
  coverLoading: {
    position: 'absolute',
  },
  inCoverContent: {
    justifyContent: 'space-between',
    paddingTop: 24,
  },
  backIcon: {
    margin: 16,
    tintColor: Colors.white,
  },
  backIconNoBg_true: {
    tintColor: Colors.thinDark,
  },
  inCoverInfo: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    height: 20,
    paddingHorizontal: 12,
    margin: 16,
  },
  title: {
    margin: 16,
    marginTop: 30,
  },
  desc: {
    marginHorizontal: 16,
    marginBottom: 24,
  },
  tabContainer: {
    backgroundColor: Colors.whiteSmoke,
  },
  tabbar: {
    backgroundColor: Colors.whiteSmoke,
    elevation: 0,
    shadowColor: 'transparent',
    shadowOpacity: 0,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowRadius: 0,
    marginBottom: 20,
    marginTop: 16,
  },
  labelContainer: {
    minWidth: 100,
    paddingVertical: 6,
    paddingHorizontal: 16,
    marginHorizontal: 4,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    overflow: 'hidden',
  },
  tabStyle: {
    width: 'auto',
    backgroundColor: Colors.whiteSmoke,
    padding: 0,
    overflow: 'hidden',
  },
  list: {
    backgroundColor: Colors.whiteSmoke,
  },
  listContentContainer: {
    backgroundColor: Colors.whiteSmoke,
  },
  listSeparator: {
    height: 1,
    marginHorizontal: 15,
    backgroundColor: Colors.veryLightPinkTwo,
  },

  itemContainer: {
    height: 70,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemIcon: {
    marginHorizontal: 16,
  },
  ctaContainer: (bottom = 0) => {
    return {
      padding: 16,
      paddingBottom: 24,
      backgroundColor: Colors.white,
      marginBottom: bottom,
    }
  },
  tagsContainer: {
    maxHeight: 20,
    marginVertical: 16,
  },
  tagsContent: {
    paddingRight: 16,
    paddingLeft: 8,
  },
  tag: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    height: 20,
    paddingHorizontal: 12,
    marginLeft: 8,
    overflow: 'hidden',
  },
})

export default styles
